/* LIBS */
import React, { Component } from 'react'
import Pdf from "react-to-pdf"
import Modal from '../../../components/Modal'
import Button from '../../../components/ui/Button'
import { formatCurrency } from '../../../../utils/money'
import { defaultTheme } from '../../../styles/themes'
import styled from 'styled-components'

const Title = styled.h1`
  font-family: ${defaultTheme.fonts.secondary};
  line-height: 1.2;
  font-size: 1.3em;
  padding-top: 10px;
`
const Group = styled.div`
  padding: 20px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  @media(max-width: 768px) {
    font-size: 12px;
    padding: 0;
  }
`
const Label = styled(Title)`
  font-family: ${defaultTheme.fonts.primary};
  padding: 5px;
  font-size: 16px;
  white-space: nowrap;
    @media(max-width: 768px) {
      font-size: 12px;
    }
`
const Tabela = styled.table`
  /* border-bottom: 1px solid #c3c3c3; */
  overflow-x: auto;
  white-space: nowrap;
  td {
    border-bottom: 1px solid #c3c3c3;
    vertical-align:middle;
    padding: 10px 10px;
    @media(max-width: 1024px) {
     padding: 5px 5px;
    }
  }
  tr:nth-child(even) { background: #fafafa; }
  tr:hover { background: #f3f6f9; }
`

class TabelaComparativaOutrosServicos extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isOpen: false,
      pagina: 1,
      convertendoParaPDF: false,
      quantidadePorPagina: 11
    }
    this.ref = React.createRef()
  }

  componentWillReceiveProps (props) {
    this.setState({ ...props },
      () => document.querySelector('body').style.overflow = this.state.isOpen ? 'hidden' : 'auto'
    )
  }

  geraPDFMultiplo = async (fornecedores, toPdf) => {
    if(this.state.pagina <= Math.ceil(fornecedores.length / this.state.quantidadePorPagina)) {
      await toPdf()
      this.setState({
        pagina: this.state.pagina + 1,
        convertendoParaPDF: (this.state.pagina + 1) <= Math.ceil(fornecedores.length / this.state.quantidadePorPagina)
      }, async () => {
        this.geraPDFMultiplo(fornecedores, toPdf)
      })
    }
  }

  render () {
    const fornecedores = !this.state.convertendoParaPDF ?
      this.props.dadosOutrosServicos.filter(fornecedor =>
        fornecedor.services.some(item => item === 'OTHER_SERVICES') &&
        fornecedor.budgets.otherServicesBudgets && fornecedor.budgets.otherServicesBudgets.length > 0) :
      this.props.dadosOutrosServicos.filter(fornecedor =>
        fornecedor.services.some(item => item === 'OTHER_SERVICES') &&
        fornecedor.budgets.otherServicesBudgets && fornecedor.budgets.otherServicesBudgets.length > 0).slice(((this.state.pagina * this.state.quantidadePorPagina) - this.state.quantidadePorPagina), (this.state.pagina * this.state.quantidadePorPagina))
    return (
      <Modal maxWidth={'1000px'} isOpen={this.state.isOpen} hasCloseButton onClose={() => this.props.onClose && this.props.onClose()}>
        <Pdf options={{ orientation: 'landscape' }} targetRef={this.ref} filename="tabela-comparativa-outros-servicos.pdf">
          {({ toPdf }) => <Button
            onClick={() => {
              this.setState({
                convertendoParaPDF: true,
                pagina: 1
              }, async () => {
                this.geraPDFMultiplo(fornecedores, toPdf)
              })
            }}
            category={'secondary'}
            fontWeight={800}
            style={{ width: '150px', position: 'absolute', right: '10px', top: '35px' }}
            small
            full>
            Baixar em PDF
          </Button>}
        </Pdf>
        <Group ref={this.ref} style= {{align: 'center'}}>
          <Title style={{ textAlign: 'left', marginBottom: '30px' }}>Tabela Comparativa de Fornecedores</Title>
          <Tabela>
            <tbody>
              <tr>
                <td><Label>Fornecedor</Label></td>
                <td><Label>Valor total</Label></td>
              </tr>
              {fornecedores.map(fornecedor => (
                <tr>
                  <td>
                    <Label style={{ fontWeight: '900' }}>{fornecedor.name}</Label>
                  </td>
                  <td>
                    <Label style={{ fontWeight: '900' }}>{formatCurrency(fornecedor.budgets.otherServicesBudgets.find(item => item.status === 'ACTIVE') ? fornecedor.budgets.otherServicesBudgets.find(item => item.status === 'ACTIVE').cheapestTotalPrice.amount : 0)}</Label>
                  </td>
                </tr>
                ))}
            </tbody>
          </Tabela>
        </Group>
      </Modal>
    )
  }
}

export default TabelaComparativaOutrosServicos
